import { getCurrentUser } from 'domains/current_user';
import ky from 'ky';
import { Income } from 'types';
import DEFAULT_OPTION from './default_option';

type IncomesResponse = {
  incomes: Income[];
};

type IncomeResponse = {
  income: Income;
};

type EmptyResponse = Record<string, never>;

const getIncomesWithParams = async (
  year: number,
  month: number,
): Promise<IncomesResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    searchParams: { year, month },
    throwHttpErrors: true,
  };

  const response = await ky.get('incomes', options);

  return response.json();
};

export const getIncomes = async (
  year: number | null = null,
  month: number | null = null,
): Promise<IncomesResponse> => {
  if (year && month) {
    return getIncomesWithParams(year, month);
  }

  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get('incomes', options);

  return response.json();
};

export const postIncome = async (income: Income): Promise<IncomeResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: {
      income,
    },
    throwHttpErrors: true,
  };

  const response = await ky.post('incomes', options);

  return response.json();
};

export const patchIncome = async (income: Income): Promise<IncomeResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: {
      income,
    },
    throwHttpErrors: true,
  };

  const response = await ky.patch(`incomes/${income.id}`, options);

  return response.json();
};

export const deleteIncome = async (income: Income): Promise<EmptyResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.delete(`incomes/${income.id}`, options);

  return response.json();
};
